import { render, staticRenderFns } from "./vr-repeat.vue?vue&type=template&id=4d37ab29&scoped=true"
import script from "./vr-repeat.vue?vue&type=script&lang=js"
export * from "./vr-repeat.vue?vue&type=script&lang=js"
import style0 from "./vr-repeat.vue?vue&type=style&index=0&id=4d37ab29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d37ab29",
  null
  
)

export default component.exports